import { z } from 'zod';
import { lt, Validation } from '@mews/framework';
import { Stack } from '@optimus-web/core';
import { SchemaFormDefinition, SchemaFormFields } from '@mews-commander/form';
import { PaymentMappingsList } from '../paymentMappings/PaymentMappingList';
import { ServingtimeMappingsList } from '../servingtimeMappings/ServingtimeMappingList';

const xmlPosOutletFormSchema = z.object({
    name: Validation.String.Required.default(''),
    menuNumber: Validation.String.Required.default(''),
    outletBillId: z.string().nullable().default(null),
});

const xmlPosOutletFormDefinition: SchemaFormDefinition<typeof xmlPosOutletFormSchema> = {
    fields: {
        name: { label: lt('PosRevenueCenterName') },
        menuNumber: { label: lt('PosRevenueCenterId') },
        outletBillId: { label: lt('MicrosOutletId') },
    },
    renderFields: ['name', 'menuNumber', 'outletBillId'],
};

export const XmlPosOutletForm = ({ formFormat }: { formFormat?: string }) => {
    return (
        <Stack vertical spacing="400">
            <SchemaFormFields schema={xmlPosOutletFormSchema} formDefinition={xmlPosOutletFormDefinition} />
            <ServingtimeMappingsList />
            <PaymentMappingsList formFormat={formFormat} />
        </Stack>
    );
};
